import { action } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, Duration, inject } from 'Mri.Web.Common';
import * as React from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from 'reactstrap';
import {AppStore} from "../../Core/AppStore";

export interface ILiveChartsTimeSpanSelectorProps {
    onTimeWindowChange(): void;
    readonly maxValue: Date;
    readonly timeWindow: Duration;
}

@autoinject
@observer
export class LiveChartsTimeSpanSelector extends React.Component<ILiveChartsTimeSpanSelectorProps> {
    public render() {
        return (
            <UncontrolledButtonDropdown className="ms-2">
                <DropdownToggle caret color="primary" className="btn-sm">
                    {this.appStore.storage.liveChartSettings.liveChartTimeWindow + ' Hour Window'}
                </DropdownToggle>

                <DropdownMenu>
                    <DropdownItem
                        className="text-primary"
                        onClick={e => this.onTimeWindowChange(e, 1)}
                        active={this.appStore.storage.liveChartSettings.liveChartTimeWindow == 1}
                    >
                        1 Hour
                    </DropdownItem>
                    <DropdownItem
                        className="text-primary"
                        onClick={e => this.onTimeWindowChange(e, 2)}
                        active={this.appStore.storage.liveChartSettings.liveChartTimeWindow == 2}
                    >
                        2 Hours
                    </DropdownItem>
                    <DropdownItem
                        className="text-primary"
                        onClick={e => this.onTimeWindowChange(e, 4)}
                        active={this.appStore.storage.liveChartSettings.liveChartTimeWindow == 4}
                    >
                        4 Hours
                    </DropdownItem>
                    <DropdownItem
                        className="text-primary"
                        onClick={e => this.onTimeWindowChange(e, 8)}
                        active={this.appStore.storage.liveChartSettings.liveChartTimeWindow == 8}
                    >
                        8 Hours
                    </DropdownItem>
                    <DropdownItem
                        className="text-primary"
                        onClick={e => this.onTimeWindowChange(e, 12)}
                        active={this.appStore.storage.liveChartSettings.liveChartTimeWindow == 12}
                    >
                        12 Hours
                    </DropdownItem>
                    <DropdownItem
                        className="text-primary"
                        onClick={e => this.onTimeWindowChange(e, 24)}
                        active={this.appStore.storage.liveChartSettings.liveChartTimeWindow == 24}
                    >
                        24 Hours
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledButtonDropdown>
        );
    }

    @bind
    @action
    private onTimeWindowChange(event: React.MouseEvent<HTMLElement>, v: 1 | 2 | 4 | 8 | 12 | 24) {
        event.preventDefault();

        this.appStore.storage.liveChartSettings.liveChartTimeWindow = v;
        this.appStore.storage.liveChartSettings.secsPerSample = v * 10;
        this.props.onTimeWindowChange();
    }

    @inject
    private appStore!: AppStore;
}
